import { useEffect } from "react";

const AttendanceFilters = ({ userData, filters, onChange, onApply }) => {
  const groups = userData?.data?.Groups || [];

  const branches = groups.flatMap(group =>
    (group.Branches || []).map(branch => ({
      ...branch,
      GroupId: group.GroupId,
    }))
  );

  const courses =
    branches.find(b => b.BranchId === filters.BranchId)?.Courses || [];

  /* ✅ AUTO-SELECT FIRST BRANCH */
  useEffect(() => {
    if (!filters.BranchId && branches.length > 0) {
      const firstBranch = branches[0];

      onChange(prev => ({
        ...prev,
        GroupId: firstBranch.GroupId,
        BranchId: firstBranch.BranchId,
        CourseId: "",
      }));
    }
  }, [branches]);

  /* ✅ AUTO-SELECT FIRST COURSE */
  useEffect(() => {
    if (filters.BranchId && !filters.CourseId && courses.length > 0) {
      const firstCourse = courses[0];

      onChange(prev => ({
        ...prev,
        CourseId: firstCourse.CourseId,
      }));
    }
  }, [courses, filters.BranchId]);

  return (
    <div className="attendance-filters">
      {/* BRANCH */}
      <select
        value={filters.BranchId}
        onChange={(e) => {
          const selectedBranch = branches.find(
            b => b.BranchId === e.target.value
          );

          onChange({
            ...filters,
            GroupId: selectedBranch?.GroupId || "",
            BranchId: e.target.value,
            CourseId: "",
          });
        }}
      >
        <option value="">Select Branch</option>
        {branches.map(branch => (
          <option key={branch.BranchId} value={branch.BranchId}>
            {branch.BranchName}
          </option>
        ))}
      </select>

      {/* COURSE */}
      <select
        value={filters.CourseId}
        disabled={!filters.BranchId}
        onChange={(e) =>
          onChange({
            ...filters,
            CourseId: e.target.value,
          })
        }
      >
        <option value="">Select Course</option>
        {courses.map(course => (
          <option key={course.CourseId} value={course.CourseId}>
            {course.CourseName}
          </option>
        ))}
      </select>

      {/* DATE RANGE */}
      <input
        type="date"
        value={filters.FromDate}
        onChange={(e) =>
          onChange({ ...filters, FromDate: e.target.value })
        }
      />
      <input
        type="date"
        value={filters.ToDate}
        onChange={(e) =>
          onChange({ ...filters, ToDate: e.target.value })
        }
      />

      <button onClick={onApply}>Apply</button>
    </div>
  );
};

export default AttendanceFilters;
